import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { RequisitionPayload, RequisitionResponse, RequisitionUpdateStatus } from "@/types/interface/requisition";
import { ref } from "vue";
import { db } from "@/database/db";

const loginInfo = ref();
const stringLoginInfo = await db.storage.get('login-info');
loginInfo.value = stringLoginInfo?.data;

async function create(payload: RequisitionPayload) {
  return await http.post<APIResponse<RequisitionResponse>>("requisition/create", payload);
}

async function update(idRequisition = '', payload: RequisitionPayload) {
  return await http.patch<APIResponse<RequisitionResponse>>(`requisition/update?id=${idRequisition}`, payload);
}

async function updateStatusRequisition(idRequisition = '', payload: RequisitionUpdateStatus) {
  return await http.patch<APIResponse<RequisitionResponse>>(`requisition/update-status-requisition?id=${idRequisition}`, payload);
}

async function get(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<RequisitionResponse>>(`requisition?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function getSubsmission(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  if (loginInfo?.value?.job?.id != undefined){
    queryParam = queryParam + '&job_id=' + loginInfo?.value?.job?.id;
  }
  return await http.get<APIResponse<RequisitionResponse>>(`requisition/list-submission?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function getApproval(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  if (loginInfo?.value?.job?.id != undefined){
    queryParam = queryParam + '&job_id=' + loginInfo?.value?.job?.id;
  }
  return await http.get<APIResponse<RequisitionResponse>>(`requisition/list-approval?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function getIncoming(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  if (loginInfo?.value?.job?.id != undefined){
    queryParam = queryParam + '&job_id=' + loginInfo?.value?.job?.id;
  }
  return await http.get<APIResponse<RequisitionResponse>>(`requisition/list-incoming?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function detail(idRequisition = "") {
  return await http.get<APIResponse<RequisitionResponse>>(`requisition/detail?id=${idRequisition}`);
}

async function remove(idRequisition = "") {
  return await http.delete<APIResponse<RequisitionResponse>>(`requisition/delete?id=${idRequisition}`);
}

async function submitDraft(idRequisition = '') {
  return await http.patch<APIResponse<RequisitionResponse>>(`requisition/submit-draft?id=${idRequisition}`);
}

export default {
  create,
  update,
  updateStatusRequisition,
  get,
  getSubsmission,
  getIncoming,
  getApproval,
  detail,
  remove,
  submitDraft,
};